/**
 * Live-update Loyalty brutto (sum-based) UI + free shipping on cart AJAX.
 * UA: full widget #kayer-ua-loyalty-brutto-widget
 * PL: compact [data-kayer-brutto-next] hints
 *
 * PL Loyalty thresholds live in Shopify as PLN (750 / 1350 / 1950).
 * EU markets: convert for display only — never show "750 €".
 */
(function () {
  var fxResolving = false;

  function growthMode() {
    var el = document.querySelector('[data-kayer-growth-mode]');
    return el ? el.getAttribute('data-kayer-growth-mode') || 'legacy' : 'legacy';
  }

  function moneyFmt(amount, cur, locale) {
    var n = Math.max(0, Math.ceil(Number(amount) || 0));
    var loc = locale || (cur === 'грн' ? 'uk' : cur === '€' || cur === 'EUR' ? 'en' : 'pl');
    var intl =
      loc === 'uk' || cur === 'грн'
        ? 'uk-UA'
        : loc === 'en' || cur === '€' || cur === 'EUR' || cur === '$' || cur === 'USD'
          ? 'en-IE'
          : cur === 'Kč' || cur === 'CZK'
            ? 'cs-CZ'
            : 'pl-PL';
    try {
      return n.toLocaleString(intl) + ' ' + cur;
    } catch (e) {
      return n + ' ' + cur;
    }
  }

  function curLabel(iso) {
    iso = String(iso || '').toUpperCase();
    if (iso === 'EUR') return '€';
    if (iso === 'USD') return '$';
    if (iso === 'PLN') return 'zł';
    if (iso === 'UAH') return 'грн';
    if (iso === 'CZK') return 'Kč';
    return iso || 'zł';
  }

  /** PLN→presentment rate must be sane (blocks "750 €" bug). */
  function isSaneFx(rate, shopCur, cartCur) {
    var r = Number(rate);
    if (!(r > 0)) return false;
    shopCur = String(shopCur || '').toUpperCase();
    cartCur = String(cartCur || '').toUpperCase();
    if (shopCur === cartCur) return r === 1;
    if (shopCur !== 'PLN') return r > 0 && r !== 1;
    if (cartCur === 'EUR' || cartCur === 'USD') return r > 0.12 && r < 0.45;
    if (cartCur === 'CZK') return r > 3.5 && r < 9;
    return r > 0 && r < 0.95;
  }

  function tipLocale(root) {
    var loc = (root.getAttribute('data-locale') || '').toLowerCase().slice(0, 2);
    if (loc === 'en' || loc === 'uk' || loc === 'pl') return loc;
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('/en-') === 0 || path.indexOf('/en/') === 0) return 'en';
    if (path.indexOf('/uk') === 0) return 'uk';
    return 'pl';
  }

  /** Tier math always in PLN (same as Shopify automatic discounts). */
  function calcPln(totalPln, t1, t2, t3) {
    var pctNow = 0;
    var nextAmtPln = t1;
    var nextPct = 5;
    var tier = 'base';
    if (totalPln >= t3) {
      pctNow = 15;
      nextAmtPln = 0;
      nextPct = 15;
      tier = 't15';
    } else if (totalPln >= t2) {
      pctNow = 10;
      nextAmtPln = t3 - totalPln;
      nextPct = 15;
      tier = 't10';
    } else if (totalPln >= t1) {
      pctNow = 5;
      nextAmtPln = t2 - totalPln;
      nextPct = 10;
      tier = 't5';
    } else {
      nextAmtPln = t1 - totalPln;
      nextPct = 5;
      tier = 'base';
    }
    return { pctNow: pctNow, nextAmtPln: nextAmtPln, nextPct: nextPct, tier: tier };
  }

  function tipClass(tier) {
    if (tier === 't15') return 'tier_best';
    if (tier === 't10') return 'tier_15';
    if (tier === 't5') return 'tier_10';
    return 'base';
  }

  function hitLoyaltyTitle(title) {
    var t = String(title || '').toLowerCase();
    return t.indexOf('brutto') >= 0 || t.indexOf('loyalty') >= 0;
  }

  function hitEuNetTitle(title) {
    var t = String(title || '').toLowerCase();
    return t.indexOf('eu-net') >= 0 || t.indexOf('b2b-eu') >= 0 || t.indexOf('reverse charge') >= 0;
  }

  /** Base for Loyalty thresholds = after promo (B), before Loyalty (C) and VAT (D). */
  function cartBrutto(cart) {
    var items = (cart && cart.items) || [];
    var brutto = 0;
    var promo = 0;
    var loyalty = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if ((it.quantity || 0) <= 0) continue;
      brutto += it.original_line_price || 0;
      var allocs = it.line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var title = (allocs[k].discount_application || {}).title || '';
        var amt = allocs[k].amount || 0;
        if (hitLoyaltyTitle(title)) loyalty += amt;
        else if (!hitEuNetTitle(title)) promo += amt;
      }
    }
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      var title = app.title || '';
      var amt = app.total_allocated_amount || 0;
      if (hitLoyaltyTitle(title)) loyalty += amt;
    });
    // After B, before C: brutto - promo (= items_subtotal + loyalty if C already applied as PRODUCT)
    var afterB = brutto - promo;
    if (afterB <= 0 && cart) {
      var cents =
        cart.items_subtotal_price != null
          ? cart.items_subtotal_price + loyalty
          : cart.original_total_price != null
            ? cart.original_total_price
            : cart.total_price || 0;
      afterB = cents;
    }
    return Number(afterB) / 100;
  }

  function loyaltyActuallyApplied(cart) {
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      if (hitLoyaltyTitle(apps[i].title) && apps[i].total_allocated_amount > 0) return true;
    }
    var items = (cart && cart.items) || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        if (
          hitLoyaltyTitle((allocs[k].discount_application || {}).title) &&
          allocs[k].amount > 0
        ) {
          return true;
        }
      }
    }
    return false;
  }

  function readFxSync(root) {
    var shopCur = (root.getAttribute('data-shop-currency') || 'PLN').toUpperCase();
    var cartCur = (root.getAttribute('data-cart-currency') || shopCur).toUpperCase();
    if (shopCur === cartCur) return 1;

    var baked = parseFloat(root.getAttribute('data-fx') || '0');
    if (isSaneFx(baked, shopCur, cartCur)) return baked;

    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      var r = parseFloat(Shopify.currency.rate);
      if (r > 1 && (cartCur === 'EUR' || cartCur === 'USD') && shopCur === 'PLN') {
        r = 1 / r;
      }
      if (isSaneFx(r, shopCur, cartCur)) {
        root.setAttribute('data-fx', String(r));
        return r;
      }
    }
    return 0;
  }

  function resolveFxAsync(root, done) {
    var shopCur = (root.getAttribute('data-shop-currency') || 'PLN').toUpperCase();
    var cartCur = (root.getAttribute('data-cart-currency') || shopCur).toUpperCase();
    var sync = readFxSync(root);
    if (sync > 0) {
      done(sync);
      return;
    }
    if (shopCur === cartCur) {
      done(1);
      return;
    }
    if (fxResolving) {
      done(0);
      return;
    }
    fxResolving = true;
    var handle = root.getAttribute('data-fx-ref-handle') || 'luxio-murmur';
    var lux15 = parseFloat(root.getAttribute('data-lux15') || '110.7');
    var url = '/products/' + encodeURIComponent(handle) + '.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        fxResolving = false;
        if (!p || !p.variants || !p.variants.length || !(lux15 > 0)) {
          done(0);
          return;
        }
        var v =
          p.variants.filter(function (x) {
            return /15\s*ml/i.test(x.title || '');
          })[0] || p.variants[0];
        var presentment = Number(v.price) / 100;
        var fx = presentment / lux15;
        if (isSaneFx(fx, shopCur, cartCur)) {
          root.setAttribute('data-fx', String(fx));
          done(fx);
        } else {
          done(0);
        }
      })
      .catch(function () {
        fxResolving = false;
        done(0);
      });
  }

  function updateUaWidget(root, cart, s, a15, a9) {
    var brutto = Math.round(cartBrutto(cart));
    root.setAttribute('data-tier', s.tier);
    root.setAttribute('data-brutto', String(brutto));
    root.classList.remove(
      'kayer-ua-loyalty--base',
      'kayer-ua-loyalty--t5',
      'kayer-ua-loyalty--t10',
      'kayer-ua-loyalty--t15'
    );
    root.classList.add('kayer-ua-loyalty--' + s.tier);

    var steps = root.querySelectorAll('[data-loyalty-step]');
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].getAttribute('data-loyalty-step') === s.tier) {
        steps[i].setAttribute('aria-current', 'step');
      } else {
        steps[i].removeAttribute('aria-current');
      }
    }

    var tierLabel = root.querySelector('[data-brutto-tier-label]');
    if (tierLabel) tierLabel.textContent = s.pctNow > 0 ? '−' + s.pctNow + '%' : '0%';

    var sumEl = root.querySelector('[data-brutto-sum-text]');
    if (sumEl) sumEl.textContent = 'Сума: ' + brutto + ' грн';

    var status = '';
    var offer = '';
    if (s.tier === 't15') {
      status = 'Активовано максимальний рівень −15%';
      offer =
        'Найвищий рівень Loyalty уже застосовано. Далі — умови B2B Program (−17/−19/−21%).';
    } else if (s.tier === 't10') {
      status = 'Активовано рівень −10%';
      offer =
        'До −15% бракує ' + Math.ceil(s.nextAmt) + ' грн (≈ ' + a15 + '× Luxio 15 ml).';
    } else if (s.tier === 't5') {
      status = 'Активовано рівень −5%';
      offer =
        'До −10% бракує ' + Math.ceil(s.nextAmt) + ' грн (≈ ' + a15 + '× Luxio 15 ml).';
    } else {
      status = 'Додайте суму замовлення — знижка від суми чека ввімкнеться автоматично';
      offer =
        'До −5% бракує ' +
        Math.ceil(s.nextAmt) +
        ' грн (≈ ' +
        a15 +
        '× Luxio 15 ml або ' +
        a9 +
        '× Luxio 9 ml).';
    }

    var statusEl = root.querySelector('[data-brutto-status-text]');
    if (statusEl) statusEl.textContent = status;
    var nextEl = root.querySelector('[data-brutto-next-text]');
    if (nextEl) nextEl.textContent = offer;
    var offerEl = root.querySelector('[data-brutto-offer-text]');
    if (offerEl) offerEl.textContent = offer;

    var t3 = parseFloat(root.getAttribute('data-t3') || '8500');
    var pct = Math.max(0, Math.min(100, Math.floor((brutto * 100) / t3)));
    var bar = root.querySelector('[data-brutto-bar-fill]');
    if (bar) bar.style.width = pct + '%';
    var progress = root.querySelector('[data-brutto-progress]');
    if (progress) progress.setAttribute('aria-valuenow', String(brutto));
  }

  function updateCompactTip(root, s, a15, a9, cur, b2b, shop, locale) {
    var nextEl = root.querySelector('[data-kayer-brutto-next]');
    if (!nextEl) return;
    var tipTier = tipClass(s.tier);
    nextEl.className = 'cart__volume-tier-hint cart__volume-tier-hint--' + tipTier;
    nextEl.setAttribute('data-tier', tipTier);
    var loc = locale || (shop === 'ua' ? 'uk' : 'pl');
    var amt = moneyFmt(s.nextAmt, cur, loc);

    var html;
    if (s.nextAmt <= 0) {
      if (loc === 'uk' || shop === 'ua') {
        html =
          '💡 У вас уже максимальний Loyalty −15%. Дивіться умови <a href="' +
          b2b +
          '">B2B Program</a> (−17/−19/−21%).';
      } else if (loc === 'en') {
        html =
          '💡 You already have maximum Loyalty −15%. See <a href="' +
          b2b +
          '">B2B Program</a> terms (−17/−19/−21%).';
      } else {
        html =
          '💡 Masz już maksymalny Loyalty −15%. Sprawdź warunki <a href="' +
          b2b +
          '">B2B Program</a> (−17/−19/−21%).';
      }
    } else if (s.pctNow > 0) {
      if (loc === 'uk' || shop === 'ua') {
        html =
          '💡 Діє Loyalty −' +
          s.pctNow +
          '%. До −' +
          s.nextPct +
          '% бракує <strong>' +
          amt +
          '</strong> (≈ ' +
          a15 +
          '× Luxio 15 ml або ' +
          a9 +
          '× Luxio 9 ml).';
      } else if (loc === 'en') {
        html =
          '💡 Loyalty −' +
          s.pctNow +
          '% applied. <strong>' +
          amt +
          '</strong> more to reach −' +
          s.nextPct +
          '% (≈ ' +
          a15 +
          '× Luxio 15 ml or ' +
          a9 +
          '× Luxio 9 ml).';
      } else {
        html =
          '💡 Obowiązuje Loyalty −' +
          s.pctNow +
          '%. Do −' +
          s.nextPct +
          '% brakuje <strong>' +
          amt +
          '</strong> (≈ ' +
          a15 +
          '× Luxio 15 ml lub ' +
          a9 +
          '× Luxio 9 ml).';
      }
    } else {
      if (loc === 'uk' || shop === 'ua') {
        html =
          '💡 До першого порогу Loyalty −' +
          s.nextPct +
          '% бракує <strong>' +
          amt +
          '</strong> (≈ ' +
          a15 +
          '× Luxio 15 ml або ' +
          a9 +
          '× Luxio 9 ml).';
      } else if (loc === 'en') {
        html =
          '💡 <strong>' +
          amt +
          '</strong> more to reach the first Loyalty −' +
          s.nextPct +
          '% threshold (≈ ' +
          a15 +
          '× Luxio 15 ml or ' +
          a9 +
          '× Luxio 9 ml).';
      } else {
        html =
          '💡 Do pierwszego progu Loyalty −' +
          s.nextPct +
          '% brakuje <strong>' +
          amt +
          '</strong> (≈ ' +
          a15 +
          '× Luxio 15 ml lub ' +
          a9 +
          '× Luxio 9 ml).';
      }
    }
    nextEl.innerHTML = html;
  }

  function updateLadderHint(root, t1, t2, t3, cur, locale) {
    var el = root.querySelector('[data-kayer-brutto-ladder]');
    if (!el) return;
    var loc = locale || 'pl';
    var a = moneyFmt(t1, cur, loc);
    var b = moneyFmt(t2, cur, loc);
    var c = moneyFmt(t3, cur, loc);
    if (loc === 'en') {
      el.textContent =
        'Buy more and save (based on cart value): from ' +
        a +
        ' −5%, from ' +
        b +
        ' −10%, from ' +
        c +
        ' −15%.';
    } else if (loc === 'uk') {
      el.textContent =
        'Купуйте більше і заощаджуйте (від суми кошика): від ' +
        a +
        ' −5%, від ' +
        b +
        ' −10%, від ' +
        c +
        ' −15%.';
    } else {
      el.textContent =
        'Kupuj więcej i oszczędzaj (od wartości koszyka): od ' +
        a +
        ' −5%, od ' +
        b +
        ' −10%, od ' +
        c +
        ' −15%.';
    }
  }

  function applyBrutto(root, cart, rate) {
    var shopCur = (root.getAttribute('data-shop-currency') || 'PLN').toUpperCase();
    var cartCur = (root.getAttribute('data-cart-currency') || shopCur).toUpperCase();
    if (cart && cart.currency) {
      cartCur = String(cart.currency).toUpperCase();
      root.setAttribute('data-cart-currency', cartCur);
    }

    var t1Pln = parseFloat(root.getAttribute('data-t1') || '750');
    var t2Pln = parseFloat(root.getAttribute('data-t2') || '1350');
    var t3Pln = parseFloat(root.getAttribute('data-t3') || '1950');
    var lux15Pln = parseFloat(root.getAttribute('data-lux15') || '110.7');
    var lux9Pln = parseFloat(root.getAttribute('data-lux9') || '81.18');
    var b2b = root.getAttribute('data-b2b') || '/pages/b2b';
    var shop = root.getAttribute('data-shop') || 'pl';
    var locale = tipLocale(root);

    var fxOk = shop === 'ua' || shopCur === cartCur || isSaneFx(rate, shopCur, cartCur);
    var fx = fxOk ? rate || 1 : 0;
    var cur = fxOk && shopCur !== cartCur ? curLabel(cartCur) : curLabel(shop === 'ua' ? 'UAH' : shopCur);
    if (!fxOk && shopCur !== cartCur) cur = 'zł';
    root.setAttribute('data-cur', cur);

    var totalPresentment = cartBrutto(cart);
    var totalPln =
      shop === 'ua' || shopCur === cartCur || !fxOk ? totalPresentment : totalPresentment / fx;

    var raw = calcPln(totalPln, t1Pln, t2Pln, t3Pln);
    var displayFx = fxOk && fx > 0 ? fx : 1;
    var s = {
      pctNow: raw.pctNow,
      nextPct: raw.nextPct,
      tier: raw.tier,
      nextAmt: raw.nextAmtPln * (fxOk && shopCur !== cartCur ? fx : 1),
    };
    // Only say "Loyalty −X% applied" if Shopify actually allocated it.
    if (shop !== 'ua' && s.pctNow > 0 && !loyaltyActuallyApplied(cart)) {
      s.pctNow = 0;
      s.tier = 'base';
    }

    var lux15 = lux15Pln * (fxOk && shopCur !== cartCur ? displayFx : 1);
    var lux9 = lux9Pln * (fxOk && shopCur !== cartCur ? displayFx : 1);
    var a15 = s.nextAmt > 0 ? Math.ceil(s.nextAmt / lux15) : 0;
    var a9 = s.nextAmt > 0 ? Math.ceil(s.nextAmt / lux9) : 0;

    var t1Show = t1Pln * (fxOk && shopCur !== cartCur ? fx : 1);
    var t2Show = t2Pln * (fxOk && shopCur !== cartCur ? fx : 1);
    var t3Show = t3Pln * (fxOk && shopCur !== cartCur ? fx : 1);

    if (root.id === 'kayer-ua-loyalty-brutto-widget') {
      updateUaWidget(root, cart, s, a15, a9);
    }
    updateLadderHint(root, t1Show, t2Show, t3Show, cur, locale);
    updateCompactTip(root, s, a15, a9, cur, b2b, shop, locale);
  }

  function updateBrutto(cart) {
    var root = document.querySelector('[data-kayer-brutto-loyalty="1"]');
    if (!root || growthMode() !== 'new') return;

    if (cart && cart.currency) {
      root.setAttribute('data-cart-currency', String(cart.currency).toUpperCase());
    }

    var rate = readFxSync(root);
    applyBrutto(root, cart, rate);

    if (!(rate > 0)) {
      resolveFxAsync(root, function (fx) {
        if (fx > 0) applyBrutto(root, cart, fx);
      });
    }
  }

  function updateFreeShipping(cart) {
    var el = document.getElementById('cart-free-shipping-msg');
    if (!el) return;
    var sub =
      Number(
        cart.original_total_price != null ? cart.original_total_price : cart.total_price
      ) || 0;
    var thrPln =
      parseInt(el.getAttribute('data-free-threshold-pln-cents') || '50000', 10) || 50000;
    var thr =
      parseInt(el.getAttribute('data-free-threshold-cents') || String(thrPln), 10) || thrPln;
    var root = document.querySelector('[data-kayer-brutto-loyalty="1"]');
    var shop = root ? root.getAttribute('data-shop') : 'pl';
    var locale = root ? tipLocale(root) : 'pl';
    var shopCur = root
      ? (root.getAttribute('data-shop-currency') || 'PLN').toUpperCase()
      : 'PLN';
    var cartCur = cart && cart.currency ? String(cart.currency).toUpperCase() : shopCur;

    // 500 zł → presentment (don't compare PLN groszy to EUR cents).
    if (shop === 'pl' && shopCur === 'PLN' && cartCur !== 'PLN' && root) {
      var rate = readFxSync(root);
      if (isSaneFx(rate, shopCur, cartCur)) {
        thr = Math.round(thrPln * rate);
        el.setAttribute('data-free-threshold-cents', String(thr));
      }
    }

    var qualifiedMsg = el.getAttribute('data-msg-qualified') || '';
    var addMoreTpl = el.getAttribute('data-msg-add-more') || '';

    function fmtRem(cents) {
      if (window.theme && theme.Currency) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }
      return (cents / 100).toFixed(2) + (cartCur === 'EUR' ? ' €' : cartCur === 'PLN' ? ' zł' : '');
    }

    if (shop === 'ua' && qualifiedMsg) {
      if (sub >= thr) {
        el.classList.remove('cart__free-shipping--no');
        el.classList.add('cart__free-shipping--yes');
        el.textContent = qualifiedMsg;
      } else {
        el.classList.add('cart__free-shipping--no');
        el.classList.remove('cart__free-shipping--yes');
        el.textContent = String(addMoreTpl).split('__amount__').join(fmtRem(thr - sub));
      }
      return;
    }

    var yes =
      qualifiedMsg ||
      (locale === 'en'
        ? 'Free shipping from 500 zł — you qualify!'
        : locale === 'uk'
          ? 'Безкоштовна доставка від 500 zł — маєте!'
          : 'Darmowa dostawa od 500 zł — masz!');
    var noTpl =
      addMoreTpl ||
      (locale === 'en'
        ? 'Add __amount__ more for free shipping (threshold 500 zł).'
        : locale === 'uk'
          ? 'Додайте ще __amount__ до безкоштовної доставки (поріг 500 zł).'
          : 'Dodaj jeszcze __amount__ do darmowej dostawy.');

    if (sub >= thr) {
      el.className = 'cart__free-shipping cart__free-shipping--yes';
      el.textContent = yes;
    } else {
      el.className = 'cart__free-shipping cart__free-shipping--no';
      el.textContent = String(noTpl).split('__amount__').join(fmtRem(thr - sub));
    }
  }

  /** Effective Loyalty % from after-promo brutto (before VAT). Used to pick EU-NET code. */
  window.kayerLoyaltyPctForCart = function (cart) {
    if (!cart) return 0;
    var root = document.querySelector('[data-kayer-brutto-loyalty="1"]');
    var t1 = 750;
    var t2 = 1350;
    var t3 = 1950;
    var shopCur = 'PLN';
    var cartCur = cart.currency ? String(cart.currency).toUpperCase() : 'PLN';
    if (root) {
      t1 = parseFloat(root.getAttribute('data-t1') || '750');
      t2 = parseFloat(root.getAttribute('data-t2') || '1350');
      t3 = parseFloat(root.getAttribute('data-t3') || '1950');
      shopCur = (root.getAttribute('data-shop-currency') || 'PLN').toUpperCase();
      if (cart.currency) root.setAttribute('data-cart-currency', cartCur);
      else cartCur = (root.getAttribute('data-cart-currency') || shopCur).toUpperCase();
    }
    var presentment = cartBrutto(cart);
    var totalPln = presentment;
    if (shopCur === 'PLN' && cartCur !== 'PLN' && root) {
      var fx = readFxSync(root);
      if (isSaneFx(fx, shopCur, cartCur)) totalPln = presentment / fx;
    }
    return calcPln(totalPln, t1, t2, t3).pctNow;
  };

  window.kayerUpdateBruttoLoyaltyHints = function (cart) {
    if (!cart) return;
    updateBrutto(cart);
    updateFreeShipping(cart);
  };

  document.addEventListener('cart:updated', function (ev) {
    var cart = ev.detail && ev.detail.cart;
    if (cart) window.kayerUpdateBruttoLoyaltyHints(cart);
  });

  function bootFromCartJs() {
    if (growthMode() !== 'new') return;
    if (!document.querySelector('[data-kayer-brutto-loyalty="1"]')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart) window.kayerUpdateBruttoLoyaltyHints(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFromCartJs);
  } else {
    bootFromCartJs();
  }
})();
